var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeOnOutline = function SvgVolumeOnOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.922 19.527a8.1 8.1 0 0 0 4.953-7.472 8.154 8.154 0 0 0-5.248-7.589.5.5 0 0 0-.354.936 7.15 7.15 0 0 1 4.602 6.653 7.102 7.102 0 0 1-4.342 6.55.5.5 0 0 0 .39.922Zm-1.356-3.548a4.253 4.253 0 0 0 2.6-3.924 4.282 4.282 0 0 0-2.755-3.986.5.5 0 0 0-.354.936 3.277 3.277 0 0 1 2.11 3.05 3.255 3.255 0 0 1-1.99 3.003.5.5 0 1 0 .389.92ZM3.125 14.606h3.774c.089 0 .176.024.252.068L11.6 17.27V6.73L7.15 9.326a.498.498 0 0 1-.252.068H3.125v5.212Zm8.975 4.035a.5.5 0 0 1-.252-.068l-5.084-2.967H2.625a.5.5 0 0 1-.5-.5V8.894a.5.5 0 0 1 .5-.5h4.139l5.083-2.967a.5.5 0 0 1 .753.432v12.282a.5.5 0 0 1-.5.5Z",
    fill: "currentColor"
  })));
};
export default SvgVolumeOnOutline;